"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const infoAZOptions = [{
  id: 0,
  title: "A",
  value: "A"
}, {
  id: 1,
  title: "B",
  value: "B"
}, {
  id: 2,
  title: "C",
  value: "C"
}, {
  id: 3,
  title: "D",
  value: "D"
}, {
  id: 4,
  title: "E",
  value: "E"
}, {
  id: 5,
  title: "F",
  value: "F"
}, {
  id: 6,
  title: "G",
  value: "G"
}, {
  id: 7,
  title: "H",
  value: "H"
}, {
  id: 8,
  title: "I",
  value: "I"
}, {
  id: 9,
  title: "J",
  value: "J"
}, {
  id: 10,
  title: "K",
  value: "K"
}, {
  id: 11,
  title: "L",
  value: "L"
}, {
  id: 12,
  title: "M",
  value: "M"
}, {
  id: 13,
  title: "N",
  value: "N"
}, {
  id: 14,
  title: "O",
  value: "O"
}, {
  id: 15,
  title: "P",
  value: "P"
}, {
  id: 16,
  title: "Q",
  value: "Q"
}, {
  id: 17,
  title: "R",
  value: "R"
}, {
  id: 18,
  title: "S",
  value: "S"
}, {
  id: 19,
  title: "T",
  value: "T"
}, {
  id: 20,
  title: "U",
  value: "U"
}, {
  id: 21,
  title: "V",
  value: "V"
}, {
  id: 22,
  title: "W",
  value: "W"
}, {
  id: 23,
  title: "X",
  value: "X"
}, {
  id: 24,
  title: "Y",
  value: "Y"
}, {
  id: 25,
  title: "Z",
  value: "Z"
}];
var _default = exports.default = infoAZOptions;